import React from 'react';
import './DatingTips.css';

const DatingTipsComponent = () => {
  return (
    <div className="container-1024">
      <div className="tips-area">
        <h3>Dating Safety Tips</h3>
        <div className="tips-content">
          <div className="tips-center-details">
            <div className="tips-section">
              <h4>1. Create a private, anonymous email.</h4>
              <p>
                Never post your real name publicly. Set up a new Gmail or Yahoo email exclusively for dating. This keeps your identity protected and your main inbox free of unwanted messages.
              </p>
            </div>

            <div className="tips-section">
              <h4>2. Don't send money. Ever.</h4>
              <p>
                No matter how sad the story, never send cash, crypto, gift cards, or share bank info. Romance scammers use emotional manipulation, fake crises, or urgent travel issues to get you to send money. Don't fall for it.
              </p>
            </div>

            <div className="tips-section">
              <h4>3. Be careful with phone numbers.</h4>
              <p>
                If someone gives you a toll-free or suspicious number, be cautious. Toll-free numbers can forward to anywhere, and scammers use them to mask their location. Use caller ID protection.
              </p>
            </div>

            <div className="tips-section">
              <h4>4. Stay on KissDateLove.com to message.</h4>
              <p>
                If someone is real, they'll talk to you here. Moving to private messaging apps too soon (WhatsApp, Telegram, etc.) is a red flag. Our platform is monitored to help protect you.
              </p>
            </div>

            <div className="tips-section">
              <h4>5. Take your time & verify everything.</h4>
              <p>
                Scammers rush. They'll try to create intense emotional connections quickly. Ask questions. Video chat. Look for inconsistencies in their story or personality. Ask yourself: does it all add up?
              </p>
            </div>

            <div className="tips-section">
              <h4>6. Reverse image search their photos.</h4>
              <p>
                Many scammers use stolen model or influencer photos. Right-click their profile pic and reverse image search it with Google. If it appears all over the internet, it's probably fake.
              </p>
            </div>

            <div className="tips-section">
              <h4>7. Don't overshare personal info.</h4>
              <p>
                Keep your full name, address, job, children's info, daily routine, and vacation plans private until you truly trust someone. Scammers piece together clues to exploit you.
              </p>
            </div>

            <div className="tips-section">
              <h4>8. Ask about past relationships.</h4>
              <p>
                A good way to understand someone's patterns and personality. Inconsistent answers or vague replies may be signs they're hiding something—or someone.
              </p>
            </div>

            <div className="tips-section">
              <h4>9. Meet in public. Always.</h4>
              <p>
                The first few dates should be in a busy public place, like a café, mall, or park. Let a friend know where you're going and when. Arrange your own ride. Never rely on your date for transportation.
              </p>
            </div>

            <div className="tips-section">
              <h4>10. Watch your drink and belongings.</h4>
              <p>
                Only accept drinks from bar staff. Don't leave your drink unattended. Keep your phone, purse, and keys in sight and secure.
              </p>
            </div>

            <div className="tips-section">
              <h4>11. Long-distance relationships require extra caution.</h4>
              <p>
                Be wary of people who claim to be working overseas or can't meet in person. It's a classic scam scenario. Use video calls, verify details, and question anyone who avoids meeting up.
              </p>
            </div>

            <div className="tips-section">
              <h4>12. Talk to them on the phone or video.</h4>
              <p>
                Listen for background clues—does what you hear match their story? No video call = a major red flag. Some scammers use fake video filters or stall indefinitely.
              </p>
            </div>

            <div className="tips-section">
              <h4>13. Know the signs of catfishing.</h4>
              <p>
                If they're too good to be true, refuse to video chat, dodge real-life meetups, or get defensive when questioned—they may not be who they say they are.
              </p>
            </div>

            <div className="tips-section">
              <h4>14. Practice safe intimacy.</h4>
              <p>
                Consent is everything. Respect your partner's comfort level. Use protection and never pressure someone into intimacy. Safe, clear communication builds trust.
              </p>
            </div>

            <div className="tips-section">
              <h4>15. Trust your instincts.</h4>
              <p>
                That gut feeling? Listen to it. If something feels off—even if you can't explain why—it probably is. Your safety always comes first.
              </p>
            </div>

            <div className="tips-section">
              <h4>16. Report suspicious behavior.</h4>
              <p>
                Help protect the KissDateLove community. If someone pressures you, sends weird links, asks for money, or makes you uncomfortable—report them. We take it seriously.
              </p>
            </div>

            <div className="tips-section disclaimer">
              <h4>Disclaimer</h4>
              <p>
                The safety tips provided above are for informational purposes only. While we do our best to promote a safe and positive dating environment, 
                <strong> KissDateLove.com and any individuals or companies associated with us are not responsible or liable</strong> for any actions, behaviors, or outcomes that may occur 
                as a result of online or offline interactions. Users are solely responsible for their personal safety and decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatingTipsComponent;